import { render, staticRenderFns } from "./ChangePasswordIcon.vue?vue&type=template&id=ed64914c&scoped=true&"
import script from "./ChangePasswordIcon.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordIcon.vue?vue&type=script&lang=js&"
import style0 from "./ChangePasswordIcon.vue?vue&type=style&index=0&id=ed64914c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed64914c",
  null
  
)

export default component.exports